import React from 'react';
import TargetAnimation from '../assets/multipleperson_work_dashboard.json'; // Replace with your image path
import Lottie from 'lottie-react';

const PerformanceAndStats = () => {
    const performanceData = [
        { label: "Web Development Skills", value: 95, color: "#f24e6a" },
        { label: "Shopify Store", value: 98, color: "#f5b81d" },
        { label: "E - Commerce Solutions", value: 92, color: "#00f0ff" },
        { label: "Graphic Design Skills", value: 95, color: "#3ff26c" },
        { label: "Digital Marketing Skills", value: 94, color: "#f24e6a" },
    ];

    const stats = [
        {
            count: "100 %",
            label: "Satisfaction",
            borderColor: "border-[#f24e6a]",
            textColor: "text-[#f24e6a]",
            borderBottom: "bg-[#f24e6a]",
        },
        {
            count: "347 +",
            label: "Clients",
            borderColor: "border-[#f5b81d]",
            textColor: "text-[#f5b81d]",
            borderBottom: "bg-[#f5b81d]",
        },
        {
            count: "389 +",
            label: "Projects",
            borderColor: "border-[#00f0ff]",
            textColor: "text-[#00f0ff]",
            borderBottom: "bg-[#00f0ff]",
        },
        {
            count: "33",
            label: "Employee",
            borderColor: "border-[#3ff26c]",
            textColor: "text-[#3ff26c]",
            borderBottom: "bg-[#3ff26c]",
        },
    ];

    return (
        <div className="bg-black xyz1 text-white px-10 py-5">
            <h1 className="font-poppins text-2xl sm:text-3xl md:text-4xl text-center font-bold text-white pt-5 pb-5">
                Skills & Solution
            </h1>

            {/* Performance Section */}
            <div className="flex flex-col lg:flex-row items-center gap-10">
                {/* Image */}
                <div className="w-full lg:w-1/2 flex justify-center">
                    <div className="w-[300px] sm:w-[350px] md:w-[400px] lg:w-[450px]">
                        <Lottie animationData={TargetAnimation} loop={true} />
                    </div>
                </div>

                {/* Text + Progress Bars */}
                <div className="w-full lg:w-1/2">
                    <h2 className="text-white text-2xl sm:text-3xl font-bold mb-6">
                        Best Performance System <br /> with Our Team
                    </h2>


                    {performanceData.map((item, index) => (
                        <div key={index} className="mb-4">
                            <div className="flex justify-between text-sm mb-1">
                                <span>{item.label}</span>
                                <span>{item.value}%</span>
                            </div>
                            <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
                                <div
                                    className="h-full rounded-full transition-all duration-700 ease-in-out"
                                    style={{
                                        width: `${item.value}%`,
                                        backgroundColor: item.color,
                                    }}
                                ></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Stats Section */}
            <div className="mt-20 text-center">
                <h2 className="text-2xl sm:text-3xl font-poppins mb-10">
                    Best Growing Agency
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            className={`border rounded-xl p-6 ${stat.borderColor} hover:scale-105 transition-transform duration-300`}
                        >
                            <h3 className={`text-3xl font-bold mb-2 ${stat.textColor}`}>
                                {stat.count}
                            </h3>
                            <p className="text-sm text-white">{stat.label}</p>
                            <div className={`h-[2px] w-full mt-4 ${stat.borderBottom}`}></div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PerformanceAndStats;
